
import { IsiIWSAssociatedViewContext } from "./IsiIwsAssociatedViewContext";
import { IIsiUIFlowResult } from "../../Core/IIsiUIFlowResult";
import { IsiDtoGLOB007OpenArgs } from "../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { GLOB007 } from "../../../Isilog.popins";
import { IGLOB007CallbackArgs } from "../../Popin/IGLOB007";
import { IsiActionContext } from "../../Core/IsiActionContext";

export class IsiArchiveProvider {

   
    /**
     * Constructeur
     */
    constructor() {
    }

    public archive(assContext: IsiIWSAssociatedViewContext, actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve) => {
            GLOB007().open(IsiDtoGLOB007OpenArgs.fromJS({
                actionContextId: actionContext.uiAction.id,
                associatedviewContextId:assContext.id
            }), {
                callback: function (result: IGLOB007CallbackArgs) {
                    resolve(result);
                }
            });
        })
    }   
}
